import { render, staticRenderFns } from "./ShowLetter.vue?vue&type=template&id=04add4c7&scoped=true&"
import script from "./ShowLetter.vue?vue&type=script&lang=js&"
export * from "./ShowLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04add4c7",
  null
  
)

export default component.exports